export default __webpack_public_path__ + "static/media/login-circles.9cda3150.png";